import React, { FunctionComponent } from 'react';

import { captureException } from '@sentry/browser';
import { useDeepCompareEffectNoCheck } from 'use-deep-compare-effect';

import { QualarooLoaderDocumentQuery } from '../../../types/__generated__';
import { PageMetaContext } from '../../context/PageMetaContext';
import { useAuthenticateUser } from '../../hooks/useAuthenticateUser';
import useFullPageQuery from '../../hooks/useFullPageQuery';
import { useNotNullableContext } from '../../hooks/useNotNullableContext';
import { mapToQualarooCustomProperties } from './mapToQualarooCustomProperties';
import QualarooLoaderQuery from './QualarooLoader.gql';

export const QualarooLoader: FunctionComponent = () => {
  const { auth } = useAuthenticateUser();
  const { pageType } = useNotNullableContext(PageMetaContext);
  const { data, loading, error } = useFullPageQuery<
    QualarooLoaderDocumentQuery
  >(QualarooLoaderQuery);

  const guid = auth?.getAccessToken()?.guid;
  const legacyId = data?.page?.owner?.legacyId;
  const pageOwner = (guid && legacyId && guid === legacyId) ?? false;
  const email = auth?.getAccessToken()?.email ?? '';

  useDeepCompareEffectNoCheck(() => {
    if (loading || !data?.page) {
      return;
    }

    window._kiq = [
      ['identify', email],
      [
        'set',
        {
          pageOwner,
          causeType: pageType,
          ...mapToQualarooCustomProperties(data?.page),
        },
      ],
    ];
  }, [data?.page, loading, email, pageOwner, pageType]);

  if (error) {
    captureException(error.message);
  }

  return null;
};
